import { PRINTERS_HAS_ERROR, PRINTERS_IS_LOADING, PRINTERS_FETCH_DATA_SUCCESS,
     ADD_PRINTER_SUCCESS, DELETE_PRINTER_SUCCESS, PRINTERS_CREATE_CACHE, ENABLE_PRINTER_SUCCESS} from '../actions/printers'

   
export function printersHasError(state = null, action) {
    switch (action.type) {
        case PRINTERS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function printersIsLoading(state = false, action) {
    switch (action.type) {
        case PRINTERS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function printers(state = [], action) {
    switch (action.type) {
        case PRINTERS_FETCH_DATA_SUCCESS:
            return action.printers;

        case ADD_PRINTER_SUCCESS:
            return [action.printer, ...state];

        case DELETE_PRINTER_SUCCESS:
            return state.filter(function(item) { 
                return !action.deleted_printers.includes(item.id); 
            });

        case ENABLE_PRINTER_SUCCESS:
            return state.map(function(item) { 
                if (item.id === action.printer.id)
                {
                    item.enabled = action.printer.enabled;
                }
                return item;
            });
    
        default:
            return state;
    }
}

export function printersCache(state = [], action) {
    switch (action.type) {
        case PRINTERS_CREATE_CACHE:
            return action.printersCache;
          
        default:
            return state;
    }
}
